import { isFeature } from 'Cloud/Application/FeaturesEs6';

/* CLOUDWEB-18216 Эксперимент: разворачивание пункта "Все файлы" только в рамках сессии */
export const allFilesExpandNoSave: boolean = isFeature('all-files-expand-no-save');

/* CLOUDWEB-18216 Эксперимент: разворачивание / сворачивание пункта "Все файлы" только по стрелке */
export const allFilesExpandOnlyByArrow: boolean = isFeature('all-files-expand-only-by-arrow');
